// Supabase service for Knowledge Graph Mock Data
// Replaces knowledgeGraphMockData.js imports

import { querySupabase } from '../supabaseClient';

/**
 * Get mock data by story/sample ID
 */
export const getMockDataByStoryId = async (storyId) => {
  try {
    const records = await querySupabase('chi_knowledgegraphmock', { sample_id: storyId }, {
      limit: 1
    });
    
    if (!records || records.length === 0) return null;
    
    const record = records[0];
    
    // Transform Supabase data to component format
    return {
      entities: {
        characters: (record.graph_nodes || []).filter(n => 
          ['protagonist', 'helper', 'sacrificial', 'community'].includes(n.type)
        ),
        places: (record.graph_nodes || []).filter(n => 
          ['origin', 'destination', 'habitat', 'obstacle', 'dwelling', 'setting'].includes(n.type)
        ),
        objects: (record.graph_nodes || []).filter(n => 
          n.category === 'object' || 
          ['life_force', 'essence', 'legacy', 'bond', 'theme', 'artifact', 'symbol'].includes(n.type)
        )
      },
      nodes: record.graph_nodes || [],
      links: record.graph_links || [],
      relationships: record.graph_links || [],
      summary: record.graph_summary || {},
      totalEntities: record.total_entities || 0,
      totalRelationships: record.total_relationships || 0,
      mainThemes: record.main_themes || [],
      keyInsights: record.key_insights || ''
    };
  } catch (error) {
    console.error('Error fetching knowledge graph data:', error);
    return null;
  }
};

/**
 * Get all sample texts and their IDs
 */
export const getAllSampleTexts = async () => {
  try {
    const records = await querySupabase('chi_knowledgegraphmock', {}, {
      order_by: 'sample_id',
      order_direction: 'asc'
    });
    
    if (!records || records.length === 0) return { sampleList: [], sampleTexts: {} };
    
    const sampleList = records.map(record => ({
      id: record.sample_id,
      name: record.sample_name
    }));
    
    const sampleTexts = {};
    records.forEach(record => {
      sampleTexts[record.sample_id] = record.sample_text || '';
    });
    
    return { sampleList, sampleTexts };
  } catch (error) {
    console.error('Error fetching sample texts:', error);
    return { sampleList: [], sampleTexts: {} };
  }
};

/**
 * Get analyzed graphs (same as mock data format)
 */
export const getAnalyzedGraph = async (sampleId) => {
  return getMockDataByStoryId(sampleId);
};

// For backward compatibility
export const knowledgeGraphMockData = {
  // This will be populated async - components should use functions above
  sampleList: [],
  sampleTexts: {},
  analyzedGraphs: {}
};

